<!-- Main Content Wrapper -->
<div class="relative min-h-screen">
  <!-- Page Content -->
  <router-outlet></router-outlet>

  <app-footer></app-footer>


</div>
